const action = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><circle cx="8" cy="12.72" r="1.28"/><circle cx="8" cy="8" r="1.28"/><circle cx="8" cy="3.28" r="1.28"/></svg>',
};

export { action as default };
